import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=f12150e0&scoped=true"
import script from "./goods-list.vue?vue&type=script&lang=js"
export * from "./goods-list.vue?vue&type=script&lang=js"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=f12150e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12150e0",
  null
  
)

export default component.exports